import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.HTTP_3_0__1 = new (HttpProtocolVersion())('HTTP', 3, 0);
        this.HTTP_2_0__1 = new (HttpProtocolVersion())('HTTP', 2, 0);
        this.HTTP_1_1__1 = new (HttpProtocolVersion())('HTTP', 1, 1);
        this.HTTP_1_0__1 = new (HttpProtocolVersion())('HTTP', 1, 0);
        this.SPDY_3__1 = new (HttpProtocolVersion())('SPDY', 3, 0);
        this.QUIC_1 = new (HttpProtocolVersion())('QUIC', 1, 0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpProtocolVersionClass;
function HttpProtocolVersion() {
  if (HttpProtocolVersionClass === VOID) {
    class $ {
      constructor(name, major, minor) {
        Companion_getInstance();
        this.name_1 = name;
        this.major_1 = major;
        this.minor_1 = minor;
      }
      toString() {
        return this.name_1 + '/' + this.major_1 + '.' + this.minor_1;
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + this.major_1 | 0;
        result = imul(result, 31) + this.minor_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpProtocolVersion()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.major_1 === other.major_1))
          return false;
        if (!(this.minor_1 === other.minor_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpProtocolVersion');
    HttpProtocolVersionClass = $;
  }
  return HttpProtocolVersionClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance32hwbrsal0o03,
};
//endregion

//# sourceMappingURL=HttpProtocolVersion.mjs.map
